// const BaseUrl = ''; // 打开时候用
// const BaseUrl = ''; // 打包时候用http://vip.stdq.com/
//TODO 上线更改
// const BaseUrl = 'http://develop.0x0100.com:83/'
const BaseUrl = 'http://vip.stdq.com/'
const RequestUrl = {
    'login'                 : '/index/user.login/login_in',                 // 登录
    'signOut'               : '/index/user.login/login_out',                // 登出
    'search'                : '/index/shop.product/product_search',         // 商品搜索
    'index'                 : '/index/homepage/pc_index',                   // 首页
    'product_list'          : '/index/shop.product/product_list_by_class',  // 商品列表
    'product_detail'        : '/index/shop.product/product_detail',         // 商品详情
    'add_goods_car'         : '/index/shop.cart/add_cart',                  // 加入购物车
    'my_goods_car'          : '/index/shop.cart/my_cart',                   // 购物车
    'goods_count'           : '/index/shop.cart/cart_count',                // 获取购物车商品数量
    'romove_product'        : '/index/shop.cart/cart_product_remove',       // 删除商品
    'settlement'            : '/index/shop.order/wait_pay_pc',              // 订单详情
    'submit_order'          : '/index/shop.order/order_submit',             // 提交订单
    'get_addressData'       : '/index/user.center/address_region',          // 获取省/市/区
    'my_index'              : '/index/user.center/my_index',                // 个人中心
    'my_order'              : '/index/shop.order/my_order',                 // 我的订单
    'address_list'          : '/index/user.center/address_list',            // 地址列表
    'set_default_address'   : '/index/user.center/set_default',             // 设置默认地址
    'add_address'           : '/index/user.center/address_add',             // 添加地址
    'address_edit'          : '/index/user.center/address_edit',            // 编辑地址
    'address_delete'        : '/index/user.center/address_del',             // 删除地址
    'order_pay'             : '/index/shop.order/order_pay',                // 付款方式
    'order_pay_submit'      : '/index/shop.order/order_pay_submit',         // 订单提交
    'add_pay_img'           : '/index/shop.order/add_pay_img',              // 预购订单重复提交
    'look_order'            : '/index/shop.order/order_detail',             // 查看订单
    'cancel_order'          : '/index/shop.order/order_cancel',             // 取消订单
    'my_purse'              : '/index/user.center/my_wallet_pc',            // 我的钱包
    'send_check_code'       : '/index/user.center/send_sms',                // 发送验证码
    'modify_password'       : '/index/user.center/change_password',         // 修改密码
    'get_upyun_signature'   : '/index/user.center/get_signature',           // 请求 又拍云 上传文件签名 signature
    'modify_avatar'         : '/index/user.center/change_avatar',            // 修改头像
    'custom_sales'          : '/index/shop.order/custom_sales',             //订单下的负责人
    'new_order_submit'      : '/index/shop.order/new_order_submit',           //新订单提交
    'new_order_detail'      : '/index/shop.order/new_order_detail',         //新订单详情
    'vip_custom_list'       : '/index/user.custom/vip_custom_list', //客户列表
    'select_region':'/index/user.custom/select_region',//选择省市区
    'vip_custom_add':'/index/user.custom/vip_custom_add',//新建客户
    'vip_custom_view':'/index/user.custom/vip_custom_view',//客户详情
    'user_index':'/index/user.center/user_list',//联系人列表
    'custom_union_add':'/index/user.custom/custom_union_add',//添加团队成员
    'custom_union_del':'/index/user.custom/custom_union_del',//删除团队成员
    'add_custom_record':'/index/user.custom/add_custom_record',
    'vip_custom_edit_view':'/index/user.custom/vip_custom_edit_view',
    'vip_custom_edit_submit':'/index/user.custom/vip_custom_edit_submit',
    'accept_sms_code':'/index/user.login/accept_sms_code',
    'login_in':'/index/user.login/login_in',
    'project_list':'/index/user.project/project_list',
    'project_create':'/index/user.project/project_create',
    'project_demand_model':'/index/user.project/project_demand_model',
    'project_edit_view':'/index/user.project/project_edit_view',
    'project_edit_submit':'/index/user.project/project_edit_submit',
    'project_view':'/index/user.project/project_view',
    'project_delete':'/index/user.project/project_delete',
    'project_revoke':'/index/user.project/project_revoke',
    'apply_check':'/index/user.project/apply_check',
    'oppty_list':'/index/user.project/oppty_list',
    'oppty_deal_info':'/index/user.project/oppty_deal_info',
    'oppty_deal':'/index/user.project/oppty_deal',
    'manage_project_view':'/index/user.project/manage_project_view',
    'project_file_index':'/index/user.project/project_file_index',
    'project_file_index_same_type':'/index/user.project/project_file_index_same_type',
    'custom_file_list':'/index/user.project/custom_file_list',
    'custom_upload_file':'/index/user.project/custom_upload_file',
    'custom_file_delete':'/index/user.project/custom_file_delete',
    'model_img':'/index/api.api/model_img',
    'custom_submit':'/index/api.api/custom_submit',
    'b_to_c_project_file_index':'/index/user.project/b_to_c_project_file_index',
    'b_to_c_project_file_index_same_type':'/index/user.project/b_to_c_project_file_index_same_type',
    'b_to_c_project_file':'/index/user.project/b_to_c_project_file',
    'wait_pay_pc':'/index/shop.order/wait_pay_pc',
    'b_to_c_status_update':'/index/user.project/b_to_c_status_update',
    'c_custom_search':'/index/user.custom/c_custom_search',
    'c_custom_b_custom_bind':'/index/user.custom/c_custom_b_custom_bind',
    'productFreight':'/index/shop.order/product_freight'

};

export {
    BaseUrl,
    RequestUrl
};
